
import { h, Fragment } from 'preact'; /** @jsx h */

import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';



export const Privacy = (props) => {
    
    return <Layout.Stacked>
        <Layout.Section weight="equal">
            <h1 className="secondfont mb-3 font-weight-bold">
                Privacy Policy
            </h1>
            <p>
                Your privacy is of critical importance to us. Therefore, we have a few basic principles:
            </p>
            <ul>
                <li>
                    We are careful with the personal information we ask you to provide and
                    the personal information we collect about you through the operation of our services.
                </li>
                <li>
                    We only store personal data for as long as we have a reason to keep it. This includes
                    the use of cookies or similar technologies.
                </li>
                <li> 
                    We strive to be fully transparent about how we collect, use and share your personal data.
                </li>
            </ul>
            <p>
                Below you will find our privacy policy, which contains and explains these principles.
            </p>
            <h2>
                Information we collect
            </h2>
            <p>
                We only collect information about you when we have a valid reason to do so. These reasons
                comprise to add you as a free or paying member, to communicate with you or to improve our services.
            </p>
            <p>
                We only collect information you provide to us either explicitly by filling out a form;
                or implicitly by using our services.
            </p>
            <h3>
                Information you provide to us
            </h3>
            <p>
                We collect information you provide directly to us. Here are some examples:
            </p>
            <ul>
                <li>
                    Basic account information: We ask you for basic information to set up
                    an account. This includes your email address that serves as means to authenticate.
                </li>
                <li>
                    Payment and contact information: When you sign up for a paid subscription
                    or purchase something from us, we collect information to process those payments
                    and contact you, including your name, credit card information, and contact
                    information. We also store the purchases you make for tax and accounting purposes.
                </li>
                <li>
                    Communicating with us: You may also provide us with information when you participate
                    in surveys, communicate with us about a support request, submit a comment or
                    register for an event. If you communicate with us via a form, email or other means, we will store a copy of our communication.
                </li>
            </ul>
            <h3>
                Information we collect automatically
            </h3>
            <p>
                We collect information about visitors' usage of our website. For example, when you use our
                services (e.g., page views). We use this information to provide our services to you,
                get insights on how people use our services so we can make our services better,
                and understand and make predictions about user retention.
            </p>
            <p>
                We do not relate this information to you personally or to your account.
            </p>
            <p>
                We use the browser's local storage to keep information about your user session. This
                is required to keep you logged in accross multiple visits of our site.
            </p>

            <h2>
                Purposes for Using Information
            </h2>
            <p>
                We use any information we collect solely to run our own services. This includes:
            </p>
            <ul>
                <li>
                    To set up and maintain your account, deliver newsletters, provide customer
                    service, process payments and orders, and verify user information.
                </li>
                <li>
                    To ensure quality, maintain safety, and improve our services. For example,
                    by monitoring and analyzing how users interact with our services so we can
                    create new features that we think our users will enjoy or make our services easier to use.
                </li>
                <li>
                    To protect our services, our users, and the public. For example, by detecting security incidents;
                    detecting and protecting against malicious, deceptive, fraudulent, or illegal activity;
                    fighting spam; complying with our legal obligations; and protecting the rights and
                    property of us and others, which may result in us, for example, declining a transaction
                    or terminating services.
                </li>
                <li>
                    To communicate with you. For example, by emailing you to ask for your feedback,
                    share tips for getting the most out of our products, or keep you up to date on our services.

                </li>
            </ul>

            <h2>
                Sharing Information
            </h2>
            <p>
                We do not sell our users' data. We aren't a data broker. We don't sell your personal
                information to data brokers, and we don't sell your information to other companies
                that want to spam you with marketing emails.
            </p>
            <p>
                We share information about you in limited circumstances, and with appropriate
                safeguards for your privacy.
            </p>
            <ul>
                <li>
                    Third-party vendors: We may share information about you with third-party vendors
                    who need the information in order to provide their services to us so that we can
                    provide our services to you (like Stripe, which powers subscription payments,
                    fraud prevention services that allow us to analyze fraudulent payment transactions,
                    cloud storage services, postal and email delivery services that help us stay in
                    touch with you, customer chat and email support services that help us communicate
                    with you, registrars, registries, those that host our website, assist us with our
                    marketing efforts; those that help us understand and enhance our services
                    (like analytics providers); those that make tools to help us run our operations
                    (like programs that help us with task management, scheduling, word processing,
                    email and other communications, and collaboration among our teams);
                    and other third-party tools that help us manage operations. We only use vendors
                    that agree to similar privacy commitments in order to share information with them.
                </li>
                <li>
                    Legal and regulatory requirements: We may disclose information about you in response
                    to a subpoena, court order, or other governmental request.
                </li>
                <li>
                    To protect rights, property, and others: We may disclose information about you
                    when we believe in good faith that disclosure is reasonably necessary to protect
                    the property or rights of Dark Mode LLC, third parties, or the public at large.
                    For example, if we have a good faith belief that there is an imminent danger
                    of death or serious physical injury, we may disclose information related to
                    the emergency without delay.
                </li>
                <li>
                    Business transfers: In connection with any merger, sale of company assets,
                    or acquisition of all or a portion of our business by another company,
                    user information would likely be one of the assets that is transferred or acquired
                    by a third party. If any of these events were to happen, this Privacy Policy would
                    continue to apply to your information and the party receiving your information
                    may continue to use your information, but only consistent with this Privacy Policy.
                </li>
                <li>
                    With your consent: We may share and disclose information with your consent or at your direction.
                </li>
                <li>
                    Aggregated or de-identified information: We may share information that has been
                    aggregated or de-identified, so that it can no longer reasonably be used to identify
                    you. For instance, we may publish aggregate statistics about how many subscribers
                    we have.
                </li>
                <li>
                    Published support requests: If you send us a request for assistance (for example,
                    via a support email or one of our other feedback mechanisms), we reserve the right
                    to publish that request (without your name or identifying information attached) in
                    order to clarify or respond to your request, or to help us support other users.
                </li>
            </ul>

            <h2>
                Choices
            </h2>
            <p>
                You have several choices available when it comes to information about you and communications:
            </p>
            <ul>
                <li>
                    Limit the information that you provide: If you have an account with us,
                    you can choose not to provide the optional account information, profile information,
                    and transaction and billing information. Please keep in mind that if you do
                    not provide this information, certain features of our services — for example,
                    paid subscriber-only posts may not be accessible.
                </li>
                <li>
                    Unsubscribe from our newsletters: Free and paid subscribers may unsubscribe
                    from our newsletter at any time, either through the unsubscribe link at
                    the end of every newsletter or on the website in your account settings.
                    You cannot opt out of Service-related communications (e.g., account verification,
                    payment confirmation, changes/updates to our products or features,
                    technical and security notices.)
                </li>
                <li>
                    Close your account: While we would be very sad to see you go, you can close your
                    account if you no longer want to use our services.

                </li>
            </ul>
            
            <h2>
                Your rights
            </h2>
            <p>
                There are locations in certain parts of the world, such as California, the European Union,
                and the UK that grant you certain rights regarding your personal information, for example the
                General Data Protection Regulation (GDPR).
            </p>
            <p> 
                We believe in these rights and grant them to all our users, no matter where they are located.
                These rights include:
            </p>
            <ul>
                <li>Request access to your personal data;</li>
                <li>Request correction or deletion of your personal data;</li>
                <li>Object to our use and processing of your personal data;</li>
                <li>Request that we limit our use and processing of your personal data; and</li>
                <li>Request portability of your personal data.</li>
            </ul>
            <p>
            For processing based on your consent, you can withdraw your consent at any time. 
            </p>

            <h3>
                Contacting Us About These Rights
            </h3>
            <p>
                You can usually access, correct, or delete your personal data using your account
                settings and tools that we offer, but if you aren't able to or you'd like to contact
                us about one of the other rights, contact us by going to your account on our
                site and clicking Contact Support.

            </p>
            <p>
                When you contact us about one of your rights under this section, we'll need to verify
                that you are the right person before we disclose or delete anything.
                For example, if you are a user, we will need you to contact us from the email
                address associated with your account. You can also designate an authorized
                agent to make a request on your behalf by giving us written authorization.
                We may still require you to verify your identity with us.
            </p>

            <h2>
                Other Things You Should Know
            </h2>
            <h3>Transferring Information</h3>
            <p>
                Because our services are offered worldwide, the information about you that we process
                when you use the Services in the EU may be used, stored, and/or accessed by
                individuals operating outside the European Union (EU) who work for us,
                other members of our group of companies, or third-party data processors.
            </p>
            <p>
                When providing information about you to entities outside the EU, we will take
                appropriate measures to ensure that the recipient protects your personal information
                adequately in accordance with this Privacy Policy as required by applicable law.
                These measures include entering into European Commission approved standard contractual
                arrangements with entities based in countries outside the EU.
            </p>

            <h3>
                Creative Commons Sharealike License
            </h3>
            <p>
                We built this (customized) privacy policy using the template created by Automattic,
                the makers of WordPress, who made their Privacy Policy available under a
                Creative Commons Sharealike license. 
                You can grab a copy of their Privacy Policy and other legal documents on GitHub.
                You're more than welcome to copy ours or theirs, and adapt and repurpose them for
                your own use. Just make sure to revise the language so that your policy reflects
                your actual practices.
            </p>


        </Layout.Section>
    </Layout.Stacked>
            
}
  
